module.exports = __webpack_public_path__ + "static/media/irancell2.4a1ee135.png";